import React, { useEffect, useMemo, useState } from 'react';

// material-ui
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  MenuItem,
  Paper,
  Select,
  Slide,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
// project imports

import CheckIcon from '@mui/icons-material/Check';

// import GoogleListItemDialog from '../../components/googleDrive/googleListItems';
import { useExtractionList } from 'hooks/useExtraction';
// import HubPage from './hub';
// import ViewDataPage from './view';
import SnackbarAlert from 'components/alert/alertSnackbar';
import { useExtractionDetail } from '../../../hooks/useExtraction';
import { useAddTransform, useTransformListTemplates, useTransformNewExtraction } from '../../../hooks/useTransformation';
import { moduleTypes } from '../../../utils/utils';

const buildPairingFromDefaultConfig = (defaultConfig, accKeys) => {
  const result = {};

  if (!Array.isArray(defaultConfig) || !Array.isArray(accKeys)) {
    return result;
  }

  defaultConfig.forEach(({ to, from }) => {
    if (accKeys.includes(from)) {
      result[from] = to;
    }
  });

  return result;
};

const buildMappingsFromPairing = (pairing) => {
  return Object.entries(pairing).map(([to, from]) => ({
    from,
    to
  }));
};

export default function LoadPage({ onConfirm }) {
  const [open, setOpen] = useState(false);
  const [selectedData, setselectedData] = useState(null);
  const { data: dataExtractionDetail, isFetching, isError } = useExtractionDetail({ table: selectedData?.table_name });
  const { data: dataTransformTemplates, isFetching: isFetchingTemplates, isError: isErrorTemplates } = useTransformListTemplates();
  const { mutate: addTransform, isPending: isAddTransform, isSuccess: isSuccessAddTransform } = useAddTransform();
  const {
    mutate: newExtractionTransform,
    isPending: isNewExtractionTransform,
    isSuccess: isSuccessNewExtractionTransform
  } = useTransformNewExtraction();

  const keyExtraction = useMemo(() => dataExtractionDetail && Object.keys(dataExtractionDetail?.data[0]), [dataExtractionDetail]);

  const [typeModule, settypeModule] = useState('all');
  const {
    data: dataExtraction,
    isFetching: isLoadingExtraction,
    isError: isErrorExtraction
  } = useExtractionList({
    type: typeModule == 'all' ? '' : typeModule
  });

  const [openModal, setopenModal] = useState(false);
  const [pairing, setPairing] = useState({});
  const [editableKey, setEditableKey] = useState(null);
  const [method, setmethod] = useState('');
  const [dataFlowName, setdataFlowName] = useState('');
  const [sourceProvider, setsourceProvider] = useState('');
  const [destinationProvider, setdestinationProvider] = useState('');

  const selectedMethod = useMemo(() => dataTransformTemplates?.find((m) => m.config_name === method), [method]);

  const usedBValues = Object.values(pairing);

  const handleChange = (destinationField, sourceField) => {
    setPairing((prev) => {
      const updated = { ...prev };

      // remove old source using same destination
      Object.keys(updated).forEach((k) => {
        if (updated[k] === destinationField) delete updated[k];
      });

      if (sourceField) {
        updated[sourceField] = destinationField;
      }

      return updated;
    });
  };

  const handleSelectMethod = (config_name) => {
    const val = dataTransformTemplates?.find((m) => m.config_name === config_name);

    setdestinationProvider(val?.destination_provider);
    setPairing({});
    setmethod(config_name);
  };

  useEffect(() => {
    if (!method || !dataTransformTemplates || !keyExtraction) return;

    const val = dataTransformTemplates.find((m) => m.config_name === method);

    if (!val) return;

    if (val?.mappings?.length > 0) {
      const autoPairing = buildPairingFromDefaultConfig(val.mappings, keyExtraction);
      setPairing(autoPairing);
    } else {
      setPairing({});
    }
  }, [method, keyExtraction, dataTransformTemplates]);

  const handleDelete = (keyA) => {
    setPairing((prev) => {
      const copy = { ...prev };
      delete copy[keyA];
      return copy;
    });
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    title: '',
    content: '',
    type: 'error'
  });

  const handleCloseSnackbar = () => {
    setSnackbar({
      open: false,
      title: '',
      content: '',
      type: 'error'
    });
  };

  const handleSelectdata = (data) => {
    // console.log(data);
    setsourceProvider(data.metadata.provider);
    setselectedData(data);
    setopenModal(true);
  };

  const handleBack = () => {
    setselectedData(null);
  };

  const handleSaveTransformFlow = () => {
    const payload = {
      flow_name: dataFlowName,
      source_provider: sourceProvider,
      destination_provider: destinationProvider,
      table_extract_name: selectedData.table_name,
      module_name: selectedData.type,
      mappings: selectedMethod?.is_template ? selectedMethod.mappings : buildMappingsFromPairing(pairing)
    };

    addTransform(payload, {
      onSuccess: () => {
        setopenModal(false);
        onConfirm();
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Create New Data Flow failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleNewExtractionTransform = () => {
    const payload = {
      flow_name: dataFlowName,
      source_provider: sourceProvider,
      destination_provider: destinationProvider,
      table_extract_name: selectedData.table_name,
      module_name: selectedData.type,
      mappings: selectedMethod?.is_template ? selectedMethod.mappings : buildMappingsFromPairing(pairing)
    };
    console.log(payload);
    newExtractionTransform(payload, {
      onSuccess: () => {
        setopenModal(false);
        onConfirm();
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Create New Transform Extraction failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleCloseTransform = () => {
    setopenModal(false);
  };

  console.log({ pairing });
  const isntACC = selectedData?.type !== 'excel' && selectedData?.type !== 'spreadsheets';

  console.log({ keyExtraction, selectedMethod, dataExtractionDetail });
  return (
    <>
      {snackbar.open && <SnackbarAlert open={snackbar.open} handleClose={handleCloseSnackbar} message={snackbar} />}

      <Box>
        <Paper
          elevation={1}
          sx={{
            mt: 3,
            background: '#fff'
            // p: 1
          }}
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#ffffff' }}>
                  <TableCell>
                    <strong>Type</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Data Source</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {dataExtraction &&
                  dataExtraction?.data.map((row) => {
                    const isNotAcc = row.type !== 'excel' && row.type !== 'spreadsheets';
                    return (
                      <TableRow key={row.id}>
                        <TableCell>
                          <Typography fontWeight="bold">{moduleTypes.find((res) => res.value === row.type)?.label}</Typography>
                        </TableCell>
                        <TableCell>
                          {isNotAcc && (
                            // <Typography variant="body2" color="text.secondary">
                            //   {`${row?.metadata?.connection_user_name} |`}  {`${row?.metadata?.hub_name} |`} {row?.metadata?.project_name || row?.metadata?.name}
                            // </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {[
                                row?.metadata?.connection_user_name,
                                row?.metadata?.hub_name,
                                row?.metadata?.project_name || row?.metadata?.name
                              ]
                                .filter(Boolean)
                                .join(' | ')}
                            </Typography>
                          )}

                          {row.type == 'excel' && (
                            <Typography variant="body2" color="text.secondary">
                              {row.metadata.name}
                            </Typography>
                          )}
                          {row.type == 'spreadsheets' && (
                            <Typography variant="body2" color="text.secondary">
                              {row.metadata.name}
                            </Typography>
                          )}
                        </TableCell>

                        <TableCell align="center">
                          <Button
                            sx={{ fontWeight: 'bold' }}
                            onClick={() => handleSelectdata(row)}
                            variant="outlined"
                            //   startIcon={<VisibilityOutlinedIcon />}
                          >
                            SELECT
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>

      <Dialog maxWidth="sm" fullWidth open={openModal} onClose={handleCloseTransform}>
        <DialogTitle mx={3} id="alert-dialog-title">
          Create New Data Flow
          {isntACC && (
            // <Typography variant="body2" color="text.secondary">
            //   {selectedData?.metadata?.connection_user_name} | {selectedData?.metadata?.hub_name} |{' '}
            //   {selectedData?.metadata?.project_name || selectedData?.metadata?.name} | {selectedData?.type}
            // </Typography>
            <Typography variant="body2" color="text.secondary">
              {[
                selectedData?.metadata?.connection_user_name,
                selectedData?.metadata?.hub_name,
                selectedData?.metadata?.project_name || selectedData?.metadata?.name,
                selectedData?.type
              ]
                .filter(Boolean)
                .join(' | ')}
            </Typography>
          )}
          {selectedData?.type == 'excel' && (
            <Typography variant="body2" color="text.secondary">
              {selectedData?.metadata.name}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ py: 1 }}>
            <Box px={3} py={1}>
              <Stack spacing={2}>
                <TextField
                  value={dataFlowName}
                  onChange={(e) => setdataFlowName(e.target.value)}
                  id="outlined-basic"
                  label="Data Flow Name"
                  variant="outlined"
                />
                <Select value={method} onChange={(e) => handleSelectMethod(e.target.value)}>
                  <MenuItem value="">
                    <em>Select Method</em>
                  </MenuItem>
                  {dataTransformTemplates?.map((b) => {
                    return (
                      <MenuItem key={b.config_name} value={b.config_name}>
                        {b.config_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Stack>

              {method && (
                <Grid container spacing={3} mt={3}>
                  {/* Column A */}
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Card sx={{ height: '47vh' }}>
                      <CardContent
                        sx={{
                          height: '100%',
                          overflowY: 'auto'
                        }}
                      >
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          py={1}
                          sx={{
                            borderBottom: '1px solid',
                            borderColor: 'divider'
                          }}
                        >
                          <Typography fontWeight="bold">{selectedMethod?.source_provider.toUpperCase()}</Typography>
                          <Typography fontWeight="bold">{selectedMethod?.destination_provider.toUpperCase()}</Typography>
                        </Box>

                        <Divider sx={{ mb: 1 }} />

                        {selectedMethod?.mappings.map((a) => {
                          const selectedSource = selectedMethod?.is_template
                            ? a.from
                            : Object.keys(pairing).find((k) => pairing[k] === a.to);

                          return (
                            <Box
                              key={a.to}
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              py={1}
                              sx={{
                                borderBottom: '1px solid rgba(0,0,0,0.08)',
                                '&:last-child': { borderBottom: 'none' }
                              }}
                            >
                              {/* SOURCE FIELD */}
                              <Box width="35%">
                                <Autocomplete
                                  size="small"
                                  fullWidth
                                  disabled={selectedMethod?.is_template}
                                  options={keyExtraction || []}
                                  value={selectedSource || null}
                                  onChange={(_, newValue) => handleChange(a.to, newValue)}
                                  getOptionDisabled={(option) =>
                                    !selectedMethod?.is_template && Object.keys(pairing).includes(option) && option !== selectedSource
                                  }
                                  renderInput={(params) => <TextField {...params} placeholder="Select source field" />}
                                />
                              </Box>

                              {/* DESTINATION */}
                              <Typography sx={{ minWidth: 120, textAlign: 'right' }}>{a.to}</Typography>
                            </Box>
                          );
                        })}
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTransform}>CANCEL</Button>
          <Button loading={isNewExtractionTransform} onClick={handleNewExtractionTransform} autoFocus>
            SAVE NEW EXTRACTION
          </Button>
          <Button loading={isAddTransform} onClick={handleSaveTransformFlow} autoFocus>
            SAVE
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
